import { createRouter, createWebHistory } from 'vue-router';
//import Fragment from '@/views/trasnsctib/fragment.vue'; // Путь к компоненту Fragment.vue
import Home from '@/views/Home.vue'; // Путь к компоненту Home.vue
import store from './store';

const mainRoutes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/units',
    name: 'Подразделение',
    component: () => import('@/views/stolp/index.vue'),
  },
  {
    path: '/units/:unitId/stolp/',
    name: 'Столп',
    component: () => import('@/views/stolp/index.vue'),
    beforeEnter: (to, from, next) => {
      if(!to.params.unitId || to.params.unitId === ':unitId')
      {
        const unitId = store.getters['main/GET_USER'].CITY_ID;
        next({ name: 'Столп', params: { unitId } });  
      }
      else
      {
        if (!store.hasModule('main')) {
          import('./store/main').then(module => {
            store.registerModule('main', module.default);
            proceed(to, next);
          });
        } else {
          proceed(to, next);
        }
      }
    }
  },
  {
    path: '/units/:unitId/events/',
    name: 'Синтез-деятельность',
    component: () => import('@/views/events/index.vue'),
    beforeEnter: (to, from, next) => {
      if(!to.params.unitId || to.params.unitId === ':unitId')
      {
        const unitId = store.getters['main/GET_USER'].CITY_ID;
        next({ name: 'Синтез-деятельность', params: { unitId } });  
      }
      else
      {
        if (!store.hasModule('main')) {
          import('./store/main').then(module => {
            store.registerModule('main', module.default);
            proceed(to, next);
          });
        } else {
          proceed(to, next);
        }
      }
    }
  }
];

function proceed(to, next) {
  // Выполняем необходимые действия, например, устанавливаем значения в хранилище
  if(to.params.eventId)
    store.commit('transcrib/SET_EVENT_ID', parseInt(to.params.eventId, 10));
  else if(to.params.part)
    store.commit('transcrib/SET_PART_NUMBER', parseInt(to.params.part, 10));
  else if(to.params.fragment)
    store.commit('transcrib/SET_FRAGMENT_NUMBER', parseInt(to.params.fragment, 10));
  else if(to.params.unitId)
    store.commit('main/SET_CITY_ID', parseInt(to.params.unitId, 10));
  next(); // Продолжаем навигацию
}

const routes = [
  {
    name: 'login',
    path: '/login',
    component: () => import('@/views/login.vue'),
    meta: {
      title: 'Sign In'
    }
  },
  {
    name: 'layout',
    path: '/',
    component: () => import('@/layouts/index.vue'),
    children: mainRoutes
  },
  // ## not found page
  {
    name: 'not-found',
    path: '/:path*',
    component: () => import('@/views/error.vue'),
    meta: {
      title: 'Oh no!'
    }
  }
]




const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
